import { privateApiClient } from './apiClient';

/**
 * Service des points de vente (sites) – aligné sur le mobile.
 * Hiérarchie : Organisation → Sites (points de vente) → Terminaux (chaque terminal = 1 site + 1 caissier).
 */

/**
 * Liste des points de vente pour une organisation
 * @param {string} orgId - ID de l'organisation
 * @param {Object} params - { pge, lmt, slg }
 */
const salePointsUnavailableMessage =
    'L\'API des sites (/pos/sale-points) est indisponible sur le serveur (404). ' +
    'Vérifiez que netikash-pos-service est déployé avec SalePointController.';

function throwIfSalePointsNotFound(error) {
    if (error?.response?.status === 404) {
        throw new Error(salePointsUnavailableMessage);
    }
    throw error;
}

export const fetchSalePoints = async (orgId, params = {}) => {
    if (!orgId) return { contents: [], nextPage: null, previousPage: null };
    let data;
    try {
        ({ data } = await privateApiClient.get('/pos/sale-points', {
            params: { org: orgId, pge: 1, lmt: 100, slg: '', ...params }
        }));
    } catch (error) {
        throwIfSalePointsNotFound(error);
    }
    const contents = data?.contents ?? [];
    return {
        contents,
        nextPage: data?.nextPage ?? null,
        previousPage: data?.previousPage ?? null
    };
};

/**
 * Créer un point de vente (site)
 * @param {Object} payload - { company_id, name, address, enabled }
 */
export const createSalePoint = async (payload) => {
    let data;
    try {
        ({ data } = await privateApiClient.post('/pos/sale-points', payload));
    } catch (error) {
        throwIfSalePointsNotFound(error);
    }
    if (data?.error) throw new Error(data.message || 'Erreur lors de la création du point de vente');
    return data?.payload ?? data;
};

/**
 * Modifier un point de vente
 * @param {string} id - ID du point de vente
 * @param {Object} payload - { company_id, name, address, enabled }
 */
export const updateSalePoint = async (id, payload) => {
    let data;
    try {
        ({ data } = await privateApiClient.put(`/pos/sale-points/${id}`, payload));
    } catch (error) {
        throwIfSalePointsNotFound(error);
    }
    if (data?.error) throw new Error(data.message || 'Erreur lors de la modification');
    return data?.payload ?? data;
};

/**
 * Supprimer un point de vente
 * @param {string} id - ID du point de vente
 */
export const deleteSalePoint = async (id) => {
    let data;
    try {
        ({ data } = await privateApiClient.delete(`/pos/sale-points/${id}/delete`));
    } catch (error) {
        throwIfSalePointsNotFound(error);
    }
    if (data?.error) throw new Error(data.message || 'Erreur lors de la suppression');
    return data;
};
